"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneWaySwitcher = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const OptionsGroup_1 = require("../../../OptionsGroup");
const options = [
    {
        id: 'oneWay',
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Front/HomeSearchForm/OneWaySwitcher:OneWay', defaultMessage: 'One way' })),
    },
    {
        id: 'returnTrip',
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Front/HomeSearchForm/OneWaySwitcher:ReturnTrip', defaultMessage: 'Return trip' })),
    },
];
const OneWaySwitcher = (props) => {
    const { value, onValue } = props.field;
    const optionsGroupProps = {
        options,
        selectedIds: value ? 'oneWay' : 'returnTrip',
        select: (id) => onValue(id === 'oneWay'),
    };
    return (react_1.default.createElement(OptionsGroup_1.OptionsGroup, { ...optionsGroupProps }));
};
exports.OneWaySwitcher = OneWaySwitcher;
//# sourceMappingURL=OneWaySwitcher.js.map